module.exports = __webpack_public_path__ + "static/media/RobinHood.4ace5c37.jpg";